import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

export default function PolicyPlan({ plan }) {
  return (
    <Row className="py-2 align-items-center border-bottom">
      <Col className="fw-light text-end">
        {plan.attributes.name}
      </Col>
      <Col className="fw-semibold">
        {plan.attributes.sessions}
      </Col>
      <Col className="fw-semibold">
        {plan.attributes.employees_covered}
      </Col>
      <Col className="fw-semibold">
        {plan.attributes.available_programs}
      </Col>
    </Row>
  );
}

PolicyPlan.propTypes = {
  plan: PropTypes.object.isRequired,
};
